import { Component, OnInit } from "@angular/core";
import {
  ActionSheetController,
  AlertController,
  IonicModule,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  ToastController,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { OracaoAddPage } from "./oracao-add/oracao-add.page";
import { OracaoPessoasPage } from "./oracao-pessoas/oracao-pessoas.page";
import { OracaoRespostaPage } from "./oracao-resposta/oracao-resposta.page";
import { OracaoTestemunhoPage } from "./oracao-testemunho/oracao-testemunho.page";
import { NomenclaturaPipe } from "src/app/pipes/nomenclatura/nomenclatura";
import { OracaoProvider } from "src/app/services/oracao/oracao";
import { UserProvider } from "src/app/services/user/user";
import { ActivatedRoute, Router } from "@angular/router";
import { OracaoAdmFiltroPage } from "./oracao-adm-filtro/oracao-adm-filtro.page";
import { ModalPessoaPage } from "../modal-pessoa/modal-pessoa.page";
import { OracaoAdmAddPage } from "./oracao-adm-add/oracao-adm-add.page";
import { format, formatDistanceToNow } from "date-fns";
import { enUS, ptBR, es, it, fr, ja } from "date-fns/locale";
import { CommonModule, Location } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { NomenclaturaService } from "src/app/services/nomenclatura/nomenclatura";
import { LoadingSpinnerComponent } from "src/app/components/loading/loading-spinner/loading-spinner.component";
import { InstituicaoProvider } from "src/app/services/instituicao/instituicao";
import { AlertInput } from "@ionic/angular";
const LOCALES: Record<string, Locale> = {
  pt: ptBR,
  en: enUS,
  es: es,
  it: it,
  fr: fr,
  ja: ja,
};

@Component({
  selector: "app-oracao",
  templateUrl: "./oracao.page.html",
  styleUrls: ["./oracao.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    ImagePipe,
    NomenclaturaPipe,
    SemRegistroComponent,
    LoadingSpinnerComponent,
  ],
})
export class OracaoPage implements OnInit {
  oracoes: any = [];
  filtro: any = {};
  pagination: any = { currentPage: 0, pageCount: 0 };
  cc: any = 0;
  paginationOracao: any = { currentPage: 0, pageCount: 0, totalPendente: 0 };
  paginationMeusOracao: any = { currentPage: 0, pageCount: 0 };
  paginationTestemunhos: any = { currentPage: 0, pageCount: 0 };
  paginationMeusTestemunhos: any = { currentPage: 0, pageCount: 0 };
  oracaoList: any = [];
  testemunhoList: any = [];
  tipo: any;
  oracaoTipo: string = "publicosOracao";
  testemunhoTipo: string = "publicosTestemunhos";
  minhasOracaoList: any = [];
  meusTestemunhosList: any = [];
  loaded = false;
  nomenclaturaDesc: string = "";
  nomenclaturaTestemunho: string = "";
  tipoSegment: string = "oracao";
  isOracao: string = "0";
  instituicaoList: {
    id: string;
    nome: string;
    apiToken: any;
  }[] = [];
  btnMultigreja = false;
  tokenInstituicao: string;
  filtroTela: any = {
    publico: true,
    privado: true,
    respondido: true,
    naoRespondido: true,
    liberado: true,
    naoLiberado: true,
    testemunho: true,
    oracao: true,
    dtInicial: format(new Date(), "yyyy-MM-dd"),
    dtFinal: format(new Date(), "yyyy-MM-dd"),
    ordenacao: "2",
  };
  currentUrl: boolean;
  locale = ptBR;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public toastCtrl: ToastController,
    public oracaoProvider: OracaoProvider,
    public actionSheetCtrl: ActionSheetController,
    private nomenclatura: NomenclaturaService,
    private alertCtrl: AlertController,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    private location: Location,
    public loadingController: LoadingController,
    public router: Router,
    private translate: TranslateService,
    public active: ActivatedRoute,
    public instituicaoProvider: InstituicaoProvider
  ) {
    const locationUrl = this.location.path();
    this.currentUrl = locationUrl === "/tabs/OracaoPage" ? true : false;

    this.nomenclatura.transform("oracao").then((data) => (this.nomenclaturaDesc = data));
    this.nomenclatura.transform("testemunho").then((data) => (this.nomenclaturaTestemunho = data));
    this.tipo = this.active.snapshot.paramMap.get("params")
      ? this.active.snapshot.paramMap.get("params")
      : this.navParams.get("params");

    this.getNomenclatura(this.tipo);
    this.tokenInstituicao = this.userProvider.getTokenInstituicao();

    this.oracaoProvider.isConfiguracaoSede().subscribe((result) => {
      this.btnMultigreja = result;
    });

    this.listInstituicao();
    if (!this.userProvider.hasConfig(184)) {
      this.loadOracoes(null);
    } else {
      this.tipo == "2" ? (this.isOracao = "2") : (this.isOracao = "1");
      this.isOracao == "2" ? (this.tipoSegment = "testemunho") : (this.tipoSegment = "oracao");
      this.isOracao == "2" ? this.loadTestemunhos(null) : this.loadOracoes(null);
    }

    const currentLang = this.userProvider.linguagem || "pt";
    const locale = LOCALES[currentLang] || ptBR;
    this.locale = locale;
    this.loadAdmOracoes(null);
  }

  ngOnInit() {}

  getNomenclatura(tipo: string) {
    return tipo == "2" ? "testemunho" : "oracao";
  }

  loadTestemunhos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.paginationTestemunhos.currentPage++;
    if (!infiniteScroll) {
    }

    const idInstituicaoFiltroOracao = this.oracaoProvider.getInstituicaoFiltragem();

    this.oracaoProvider.getOracoes(this.paginationTestemunhos, 0, "1", idInstituicaoFiltroOracao).subscribe((res) => {
      this.testemunhoList = this.testemunhoList.concat(res.oracoes);

      this.paginationTestemunhos = res.pagination;

      if (infiniteScroll) {
        infiniteScroll.target.complete();
      } else {
        setTimeout(() => {
          this.loaded = true;
        }, 1000);
      }
    });
  }

  loadOracoes(infiniteScroll: { target: { complete: () => void } } | null) {
    this.paginationOracao.currentPage++;
    if (!infiniteScroll) {
    }
    this.oracaoList = [];
    const idInstituicaoFiltroOracao = this.oracaoProvider.getInstituicaoFiltragem();
    this.oracaoProvider.getOracoes(this.paginationOracao, 0, "0", idInstituicaoFiltroOracao).subscribe((res) => {
      this.oracaoList = this.oracaoList.concat(res.oracoes);
      this.paginationOracao = res.pagination;

      if (infiniteScroll) infiniteScroll.target.complete();
      else {
        this.loaded = true;
        this.oracaoProvider.getInicioOracaoAdmin().subscribe();
      }
    });
  }

  loadMinhasOracoes(infiniteScroll: { target: { complete: () => void } } | null) {
    this.paginationMeusOracao.currentPage++;

    this.oracaoProvider
      .getOracoes(this.paginationMeusOracao, 1, "0", this.userProvider.idInstituicao)
      .subscribe((res) => {
        this.minhasOracaoList = this.minhasOracaoList.concat(res.oracoes);
        this.paginationMeusOracao = res.pagination;
        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  loadMeusTestemunhos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.paginationMeusTestemunhos.currentPage++;

    this.oracaoProvider
      .getOracoes(this.paginationMeusTestemunhos, 1, "1", this.userProvider.idInstituicao)
      .subscribe((res) => {
        this.meusTestemunhosList = this.meusTestemunhosList.concat(res.oracoes);
        this.paginationMeusTestemunhos = res.pagination;

        if (infiniteScroll) infiniteScroll.target.complete();
      });
  }

  onSegmentChanged(segmentButton: any) {
    if (segmentButton.detail.value == "meusOracao" && this.minhasOracaoList.length == 0) {
      this.loadMinhasOracoes(null);
    } else if (segmentButton.detail.value == "meusTestemunhos" && this.meusTestemunhosList.length == 0) {
      this.loadMeusTestemunhos(null);
    } else if (segmentButton.detail.value == "testemunho") {
      this.testemunhoList = [];
      this.loadTestemunhos(null);
    } else if (segmentButton.detail.value == "oracao") {
      this.oracaoList = [];
      this.loadOracoes(null);
    }
  }

  oreiPorVoce(oracao: { id: any; userOrei: any; total: any }) {
    let data = { id: oracao.id, status: !oracao.userOrei };
    this.oracaoProvider.oreiPorVoce(data).subscribe((data) => {
      oracao.userOrei = data.status;
      oracao.total = data.total;
    });
  }

  async excluir(oracao: any) {
    let message = this.translate.instant("Deseja excluir a ") + this.nomenclaturaDesc + this.translate.instant(" selecionada?");

    if (oracao.isTestemunho == "1") {
      message =  message = this.translate.instant("Deseja excluir a solicitação selecionada?");
    }

    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: message,
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Excluir"),
          handler: () => {
            this.oracaoProvider.excluir(oracao.id).subscribe(() => {
              this.minhasOracaoList.splice(this.minhasOracaoList.indexOf(oracao), 1);
              this.meusTestemunhosList.splice(this.meusTestemunhosList.indexOf(oracao), 1);
            });
          },
        },
      ],
    });

    alert.present();
  }

  async denunciar(id: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Informa o Motivo"),
      inputs: [
        {
          name: this.translate.instant("Motivo"),
          placeholder: this.translate.instant("Motivo"),
        },
      ],
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: this.translate.instant("Cancelar"),
        },
        {
          text: this.translate.instant("Enviar"),
          handler: (data): any => {
            if (data.motivo) {
              let d = { id: id, motivo: data.motivo };
              this.oracaoProvider.denunciar(d).subscribe(() => {});
              // logged in!
            } else {
              // invalid login
              return false;
            }
          },
        },
      ],
    });

    alert.present();
  }

  async opcoesPublicas(oracao: { id: any }) {
    let actionSheet = await this.actionSheetCtrl.create({
      header: this.translate.instant("Opções"),
      buttons: [
        {
          text: this.translate.instant("Denunciar"),
          handler: () => {
            this.denunciar(oracao.id);
          },
        },
        {
          text: this.translate.instant("Cancelar"),
          handler: () => {
            actionSheet.dismiss();
          },
        },
      ],
    });

    actionSheet.present();
  }

  async opcoesMinhas(oracao: { isTestemunho: string }) {
    this.excluir(oracao);
  }

  async pessoasOracao(idOracao: any, isTestemunho: any) {
    var data = { idOracao: idOracao, isTestemunho: isTestemunho };
    const modalPage = await this.modalCtrl.create({
      component: OracaoPessoasPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async respostas(oracao: any) {
    var data = { oracao: oracao };
    const modalPage = await this.modalCtrl.create({
      component: OracaoRespostaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  async novoPedido(isTestemunho: any) {
    var data = { isTestemunho: isTestemunho };
    const modalPage = await this.modalCtrl.create({ component: OracaoAddPage, componentProps: data });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.minhasOracaoList = [];
      this.paginationMeusOracao = { currentPage: 0, pageCount: 0 };
      this.loadMinhasOracoes(null);
    }

    if (data.isTestemunho == true) {
      this.meusTestemunhosList = [];
      this.paginationTestemunhos = { currentPage: 0, pageCount: 0 };
      this.loadMeusTestemunhos(null);
    }
  }

  getFromNow(data: string | number | Date) {
    return formatDistanceToNow(new Date(data), { includeSeconds: true, locale: this.locale });
  }

  async testemunhar(oracao: { id: any }) {
    var data = { isTestemunho: true, idOracao: oracao.id };
    const modalPage = await this.modalCtrl.create({ component: OracaoAddPage, componentProps: data });
    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.minhasOracaoList = [];
      this.paginationMeusOracao = { currentPage: 0, pageCount: 0 };
      this.loadMinhasOracoes(null);
    }
  }

  async testemunhoOracao(oracao: { idTestemunho: any; idOracaoTestemunho: any }, isTestemunho = true) {
    if (isTestemunho) {
      const modalPage = await this.modalCtrl.create({
        component: OracaoTestemunhoPage,
        componentProps: { isTestemunho: isTestemunho, id: oracao.idTestemunho },
      });
      modalPage.present();
    } else {
      const modalPage = await this.modalCtrl.create({
        component: OracaoTestemunhoPage,
        componentProps: { isTestemunho: isTestemunho, id: oracao.idOracaoTestemunho },
      });
      modalPage.present();
    }
  }

  async privacidade(oracao: { privacidade: string; id: any }, isTestemunho: any) {
    var messsage = "";
    var pricavidadeAux = "";

    if (!isTestemunho) {
      if (oracao.privacidade == "PUBLICO") {
        messsage = "Deseja alterar a " + this.nomenclaturaDesc + " para privado?";
        pricavidadeAux = "PRIVADO";
      } else {
        messsage = "Deseja alterar a " + this.nomenclaturaDesc + " para público?";
        pricavidadeAux = "PUBLICO";
      }
    } else {
      if (oracao.privacidade == "PUBLICO") {
        messsage = "Deseja alterar o testemunho para privado?";
        pricavidadeAux = "PRIVADO";
      } else {
        messsage = "Deseja alterar o testemunho para público?";
        pricavidadeAux = "PUBLICO";
      }
    }

    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Privacidade"),
      message: this.translate.instant(messsage),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Alterar"),
          handler: () => {
            this.oracaoProvider.setPrivacidade(oracao.id, pricavidadeAux).subscribe(async (data) => {
              const toast = await this.toastCtrl.create({
                message: this.translate.instant("Privacidade alterada com sucesso!"),
                duration: 3000,
              });
              toast.present();
              oracao.privacidade = pricavidadeAux;
            });
          },
        },
      ],
    });

    alert.present();
  }

  loadAdmOracoes(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;
    const isTypeFilter = this.filtro?.isTestemunho ? this.filtro.isTestemunho : this.tipo;
    this.oracaoProvider.getAdmOracoes(this.pagination, this.filtro, isTypeFilter).subscribe((res) => {
      this.oracoes = this.oracoes.concat(res.oracoes);
      this.pagination = res.pagination;
      if (infiniteScroll) infiniteScroll.target.complete();
    });
  }

  mudarPublico(oracao: { liberado: string; id: any }) {
    let p;
    if (oracao.liberado == "1") {
      p = false;
      oracao.liberado = "0";
    } else {
      p = true;
      oracao.liberado = "1";
    }

    this.oracaoProvider.setPublico(oracao.id, p).subscribe(() => {});
  }

  async excluirOracao(oracao: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message:
        this.translate.instant("Deseja excluir a ") + this.nomenclaturaDesc + this.translate.instant(" selecionada?"),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Excluir"),
          handler: () => {
            this.oracaoProvider.excluir(oracao.id).subscribe(() => {
              this.oracoes.splice(this.oracoes.indexOf(oracao), 1);
            });
          },
        },
      ],
    });

    alert.present();
  }

  async responder(oracao: { status: string }) {
    var data = { oracao: oracao };
    const modalPage = await this.modalCtrl.create({
      component: OracaoRespostaPage,
      componentProps: data,
    });
    modalPage.present();

    const result = await modalPage.onWillDismiss();
    const retorno = result.data;
    if (retorno?.pedido.status === "2") {
      oracao.status = "1";

      this.oracoes = [];
      this.pagination = { currentPage: 0, pageCount: 0 };

      this.loadAdmOracoes(null);
    }
  }

  async filtroMensagem() {
    var data = { filtro: this.filtroTela };
    const modalPage = await this.modalCtrl.create({
      component: OracaoAdmFiltroPage,
      componentProps: data,
    });
    modalPage.present();

    const filtro = await modalPage.onWillDismiss();
    if (filtro.data) {
      this.filtro = filtro.data.filtro;
      this.filtroTela = filtro.data.filtroTela;
      this.oracoes = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadAdmOracoes(null);
    }
  }

  public async openModalPessoa(idPessoa: any) {
    var data = { idPessoa: idPessoa, meuCadastro: false };
    const modalPage = await this.modalCtrl.create({
      component: ModalPessoaPage,
      componentProps: data,
    });
    modalPage.present();
  }

  public async openNova(pedido: any) {
    var data = { pedido: pedido, tipo: this.tipo };
    const modalPage = await this.modalCtrl.create({
      component: OracaoAdmAddPage,
      componentProps: data,
    });

    modalPage.present();

    (await modalPage.onWillDismiss()).data;
    if (data) {
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.oracoes = [];
      this.loadAdmOracoes(null);
      this.listInstituicao();
    }
  }

  async opcoesAdm(oracao: { idPessoa: any }) {
    var text;
    if (this.tipo == "2") {
      text = this.translate.instant("Usar como base para criar ") + this.nomenclaturaTestemunho;
    } else if (this.tipo == "1") {
      text = this.translate.instant("Usar como base para criar ") + this.nomenclaturaDesc;
    } else {
      text =
        this.translate.instant("Usar como base para criar ") +
        this.nomenclaturaDesc +
        "/" +
        this.nomenclaturaTestemunho;
    }

    if (this.userProvider.hasPermissao("ORACAO_DADOS_CONTATO")) {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant("Opções"),
        cssClass: "my-custom-class",
        buttons: [
          {
            text: this.translate.instant("Abrir dados da pessoa"),
            handler: () => {
              this.openModalPessoa(oracao.idPessoa);
            },
          },
          {
            text: text,
            handler: () => {
              this.openNova(oracao);
            },
          },
          {
            text: this.translate.instant("Cancelar"),
            role: "cancel",
          },
        ],
      });

      actionSheet.present();
    } else {
      let actionSheet = await this.actionSheetCtrl.create({
        header: this.translate.instant("Opções"),
        buttons: [
          {
            text: text,
            handler: () => {
              this.openNova(oracao);
            },
          },
          {
            text: this.translate.instant("Cancelar"),
            role: "cancel",
          },
        ],
      });

      actionSheet.present();
    }
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  listInstituicao() {
    this.instituicaoProvider.getInstituicoesVinculadas().subscribe((data) => {
      this.instituicaoList = data;
    });
  }

  async showFilterInstituicao() {
    const idInstituicaoFiltroOracao = this.oracaoProvider.getInstituicaoFiltragem();

    let indexInstituicaoSelecionada: any;

    const inputs: AlertInput[] = this.instituicaoList.map((instituicao: { id: string; nome: string }, index: any) => {
      if (!indexInstituicaoSelecionada) {
        indexInstituicaoSelecionada = instituicao.id == idInstituicaoFiltroOracao ? index : null;
      }

      return {
        value: instituicao.id,
        label: instituicao.nome,
        type: "radio",
        checked: instituicao.id == idInstituicaoFiltroOracao,
      };
    });

    inputs.splice(0, 0, inputs.splice(indexInstituicaoSelecionada, 1)[0]);

    const alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Filtrar por Instituição:"),
      inputs: [...inputs],
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Confirmar"),
          handler: (data) => {
            this.oracaoList = [];
            this.testemunhoList = [];
            this.oracaoProvider.setInstituicaoFiltragem(data);
            this.tokenInstituicao = this.instituicaoList.find((instituicao) => instituicao.id === data)?.apiToken;
            this.tipoSegment == "testemunho" ? this.loadTestemunhos(null) : this.loadOracoes(null);
          },
        },
      ],
    });
    await alert.present();
  }

  return() {
    this.oracaoProvider.setInstituicaoFiltragem(null);
  }
}
